import yelloLine from "assests/services/11.png";
import yelloLine_ar from "assests/services/11-ar.png";
import blackLine from "assests/services/black-line-cropped.png";
import blackLine_ar from "assests/services/black-line-cropped-ar.png";
import blackRec from "assests/services/black-rec.png";
import { useState } from "react";
import ImageSliderModal from "./ImageSliderModal";
import { Plus } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import Container from "Components/Container/Container";
const Landing = ({ data }) => {
  const [activeModalIndex, setActiveModalIndex] = useState(null); // State to track which modal is open
  const { i18n, t } = useTranslation();

  const handleOpenModal = (index) => {
    setActiveModalIndex(index); // Set the index of the section whose modal should be open
  };

  const handleCloseModal = () => {
    setActiveModalIndex(null); // Close the modal by resetting the state
  };

  console.log(data?.other_servicestable);

  return (
    <div className="pt-[10vh] bg-black">
      {data?.content?.map(({ images, sub_title, title, text }, index) => (
        <div
          className={`flex  text-white ${
            index === 0 ? "bg-black " : "bg-secondary relative"
          }`}
          key={index}
        >
          <div
            className={`flex ${
              data?.length === 1 ? "lg:items-center" : ""
            } Container flex-col-reverse lg:flex-row  gap-16 py-28 ${
              index === 2 ? "border-t-[4px] border-black pt-32" : " lg:py-24"
            }`}
          >
            {index === 1 && (
              <div
                className={`absolute hidden xl:block top-0 ${
                  i18n.language === "ar"
                    ? "-left-[13.8rem] xxl:-left-[7.8rem]"
                    : "-right-[13.8rem] xxl:-right-[7.8rem]"
                } `}
              >
                <img
                  className=""
                  src={`${i18n.language === "ar" ? blackLine_ar : blackLine}`}
                  alt=""
                />
              </div>
            )}

            <div className={`${index === 3 ? "flex-[1]" : "flex-[3]"}`}>
              {title && (
                <h2
                  className={` ${
                    i18n.language === "ar" ? "titles-font-ar" : "titles-font"
                  } text-4xl mb-4 ${
                    index === 0 ? "text-secondary" : "text-primary"
                  }  capitalize`}
                >
                  {title}
                </h2>
              )}
              <div
                className={`service-content  ${
                  index === 3
                    ? "grid grid-cols-1 lg:grid-cols-2 gap-x-16 border-t-[4px] border-black pt-10"
                    : ""
                } ${index === 0 ? "font-light" : "text-black"} 
                [&>ul]:list-disc [&>ul]:pl-6 [&>ul>li]:mb-2
                [&_.nested-list]:list-circle [&_.nested-list]:pl-6 [&_.nested-list>li]:mb-1
                [&_.nested-list]:mt-2 [&_.nested-list]:ml-4`}
                dangerouslySetInnerHTML={{
                  __html: text
                    .replace(/&nbsp;/g, "")
                    .replace(/\s+/g, " ")
                    .replace(
                      /<li>([^<]*?)<ul>/g,
                      '<li>$1<ul class="nested-list">'
                    ),
                }}
              />
            </div>

            <div
              className={`relative ${index === 3 ? "hidden" : "flex-[2.2]"}`}
            >
              {index === 0 && data?.content?.length > 1 && (
                <div className="absolute right-0 top-16 hidden xl:block">
                  <img
                    className="object-contain"
                    src={`${i18n.language === "ar" ? yelloLine_ar : yelloLine}`}
                    alt=""
                  />
                </div>
              )}
              <div className="relative">
                {images.length > 1 ? (
                  <>
                    <img
                      className="relative w-[24rem] h-[24rem] mx-auto z-[10] rounded-full"
                      src={images[0]} // Show only the first image
                      alt=""
                    />
                    <button
                      className={`absolute ${
                        i18n.language === "ar" ? "left-0 " : "right-0 "
                      } -bottom-10 flex items-center gap-x-2 titles-font z-[1000]`}
                      onClick={() => handleOpenModal(index)} // Open modal on click
                    >
                      {t("view_gallery")}
                      <span className="text-2xl bg-[#333] text-white flex items-center justify-center p-2 rounded-full">
                        <Plus />
                      </span>
                    </button>
                    {activeModalIndex === index && (
                      <ImageSliderModal
                        images={images}
                        onClose={handleCloseModal}
                      />
                    )}
                  </>
                ) : (
                  <img
                    className="relative w-[24rem] h-[24rem]  mx-auto z-[10] rounded-full"
                    src={images[0]}
                    alt=""
                  />
                )}

                {index === 1 && (
                  <img
                    className="hidden xl:block absolute -left-1 xsl:left-3 xsl:-bottom-5 xxl:left-2 -bottom-4 xxl:-bottom-5   z-[100] w-[50%]"
                    src={blackRec}
                    alt=""
                  />
                )}
                {index === 2 && (
                  <img
                    className="hidden xl:block absolute -right-1 xsl:right-3 xsl:-bottom-5 xxl:right-2 -bottom-4 xxl:-bottom-5   z-[100] w-[50%] rotate-[-90deg]"
                    src={blackRec}
                    alt=""
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
      {data?.other_servicestable && (
        <div className="bg-[#000] border-b py-20 ">
          <Container>
            <p className="text-4xl text-white text-centr mb-10">
              {t("nav_other_services")}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {data?.other_servicestable?.map(
                ({ name, image, sub_title }, index) => (
                  <div
                    className=" mt-[10vh] bg-black text-white text-center"
                    key={index}
                  >
                    <img
                      className="mb-3 w-56 h-56 mx-auto rounded-full"
                      src={image}
                      alt=""
                    />
                    <h2 className="titles-font capitalize text-secondary font-bold text-3xl mb-4">
                      {name}
                    </h2>
                    {sub_title && (
                      <div className="border-l-2 border-secondary py-2 mt-1 pl-4">
                        <p className="text-white text-lg">{sub_title}</p>
                      </div>
                    )}
                  </div>
                )
              )}
            </div>
          </Container>
        </div>
      )}
    </div>
  );
};

export default Landing;
